// to easily copy and paste components
import { useState, useEffect } from 'react';
import {useTranslation} from 'react-i18next';
import { useDispatch } from 'react-redux';
import BllinkUtils from "../../common/utils/utils";
import { useAccessToken } from '../../common/hooks/useAccessToken';
import { fetchManagerBuildingData } from '../../store/buildings/actions';
import {Currency} from "../../common/currency";


export default function ExpensesRecordTotal({expenseRows, onAddLineClick, buildingID}) {
    const {t} = useTranslation();
    const client = useAccessToken();
    const dispatch = useDispatch();

    let totalAmount = BllinkUtils.Money.roundNumber(expenseRows.map((e) => parseFloat(e.amount)).reduce((a, b) => a + b, 0));

    const [currency, setCurrency] = useState('ils');

    useEffect(() => {
        (async function () {
            if (!client) return;
            const { payload: { building } } = await dispatch(fetchManagerBuildingData({
                buildingID,
                options: {urlParams: {skipDisabledCheck: true}}
            }));
            setCurrency(building.currency)
        })();
    }, [client]);

    return (
        <div className="expenses-total">
            <div className={'expenses-add'}>
                <button className={"empty-bllink-button"} onClick={onAddLineClick}>{t('expenses.add_line')}</button>
            </div>
            <div className={'expenses-amount title_wrapper'}>
                <span className={"bllink-font-title expenses-total-text"}>{t('expenses.total_amount')}:</span>
                <span className={`currency_header ${BllinkUtils.Strings.checkReverseCurrencyOrder(t(`currency.${currency}`), t) ? 'turn_currency' : ''}`}>
                    <span className={"bllink-font-title expenses-total-text"} id={'total-expense-amount'}>{BllinkUtils.Strings.numberWithCommas(totalAmount)}</span>
                    <span className={"bllink-font-title expenses-total-text"}><Currency>{currency}</Currency></span>
                </span>
                
            </div>
        </div>
    );
}

